/* ============================================================
   計測レイヤー（GA4）

   ■ 方針：計測ツールを**こちらで決めない**
     GA4の入れ方は2通りある。
       (a) GTM（タグマネージャ）を挟む → dataLayer.push でイベントを渡す
       (b) gtag.js を直接入れる        → gtag('event', ...) を呼ぶ
     **どちらを使うかは運用側の判断**なので、実装で決め打ちしない。
     このファイルは両方に流せる形にしてあり、どちらも入っていなければ
     何も起きない（エラーにもならない）。

     タグ本体はこのファイルに含めない。
     運用する人が (a) か (b) のどちらかのタグを各ページの <head> に入れるだけで、
     下のイベントがそのまま流れる。

   ■ 送っているイベント
     cta_click     … CTAボタンの押下（どのボタンかは id で判別）
     scroll_depth  … 25 / 50 / 75 / 100% への到達（各1回だけ）
     section_view  … 各セクションが画面に入った（各1回だけ＝表示率の分子になる）

   ■ このファイルの対象外
     form_start / form_submit / thanks_view の3つは、
     フォームがこのLPの中ではなく別ページにあるため、ここでは送れない。
     フォームページ側に同じ考え方で仕込む。
   ============================================================ */
(function () {
  "use strict";

  /* GTMが無くても落ちないように、無ければ自前で用意する。
     あとからGTMを入れると同じ配列を読みに行くので、後入れでも取りこぼさない */
  window.dataLayer = window.dataLayer || [];

  /* 1つのイベントを、入っている方の計測ツールへ流す。
     両方入っていれば両方に流れるが、通常はどちらか一方しか入らない */
  function push(name, params) {
    var payload = {};
    for (var k in params) {
      if (Object.prototype.hasOwnProperty.call(params, k)) payload[k] = params[k];
    }

    /* (a) GTM向け：event キーを足して dataLayer に積む */
    var forGtm = { event: name };
    for (var k2 in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, k2)) forGtm[k2] = payload[k2];
    }
    window.dataLayer.push(forGtm);

    /* (b) gtag.js を直接入れている場合はそちらにも渡す。
       入っていなければ何もしない */
    if (typeof window.gtag === "function") {
      window.gtag("event", name, payload);
    }
  }

  /* ページの識別子。1つの計測アカウントで2本のLPを見分けるために付ける */
  var page = document.body.getAttribute("data-lp") || "unknown";

  /* ---- ① CTAクリック ----
     ボタンごとに個別のリスナーを付けず、document で受け取る（委譲）。
     あとからボタンが増えても、id さえ付いていれば自動で拾える */
  document.addEventListener(
    "click",
    function (e) {
      var el = e.target.closest("a.lp-btn, button.lp-btn, .lp-stickycta a");
      if (!el) return;
      push("cta_click", {
        lp: page,
        cta_id: el.id || "(id未設定)",
        cta_text: (el.textContent || "").trim().slice(0, 40),
        link_url: el.getAttribute("href") || ""
      });
    },
    /* キャプチャ段階で拾う。ページ遷移が始まる前に確実に積むため */
    true
  );

  /* ---- ② スクロール到達率 ----
     25/50/75/100% に初めて到達したときだけ送る */
  var marks = [25, 50, 75, 100];
  var fired = {};

  function checkDepth() {
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - window.innerHeight;
    /* 1画面に収まるページでは割り算が成立しないので、到達100%として扱う */
    var pct = scrollable <= 0
      ? 100
      : ((window.pageYOffset || doc.scrollTop) / scrollable) * 100;

    marks.forEach(function (m) {
      if (!fired[m] && pct >= m) {
        fired[m] = true;
        push("scroll_depth", { lp: page, percent_scrolled: m });
      }
    });
  }

  /* 間引きに requestAnimationFrame を使わない。
     rAFはタブが非表示だと止まるため、
     「スクロールした直後にタブを切り替えた／閉じた」ときに最後の到達が記録されない。
     setTimeout なら非表示でも動くので、計測の取りこぼしが起きにくい。
     （検証環境でも実際にrAFが発火せず、この経路を確認できなかった） */
  /* 到達率とセクション表示を1つのタイマーでまとめて見る。
     checkSections は下で関数宣言しているので、ここから呼んでも巻き上げで解決される */
  function checkAll() {
    checkDepth();
    checkSections();
  }

  var timer = null;
  window.addEventListener(
    "scroll",
    function () {
      if (timer) return;
      timer = setTimeout(function () {
        timer = null;
        checkAll();
      }, 200);
    },
    { passive: true }
  );

  window.addEventListener("resize", checkAll, { passive: true });

  /* ページを離れる瞬間に取り残しがないか最後にもう一度見る。
     200msの間引きの隙間で離脱されると、そこまでの到達が消えてしまうため */
  window.addEventListener("pagehide", checkAll);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") checkAll();
  });

  checkDepth();

  /* ---- ③ セクションの表示 ----
     data-ga-section を付けた <section> が画面に入ったら1回だけ送る。
     「何%の人がそのセクションまで見たか」を出すための分子になる。

     IntersectionObserver は使わない。追従CTAでも同じ方式にしている。
       ① 通知が来ないと永久に発火せず、来ないこと自体に気づけない
       ② 検証環境では発火しないため、動いているかを確かめられない
     位置を毎回その場で測る方式なら、いつ呼んでも同じ答えが出るので検証できる。
     対象は7〜8個なので、測り直しのコストも問題にならない */
  var pending = Array.prototype.slice.call(
    document.querySelectorAll("[data-ga-section]")
  );

  function checkSections() {
    if (!pending.length) return;
    var h = window.innerHeight;
    /* 送ったものを取り除きながら回すので、後ろから見る */
    for (var i = pending.length - 1; i >= 0; i--) {
      var el = pending[i];
      var r = el.getBoundingClientRect();
      /* 画面に25%以上入ったら「見た」とみなす。
         端がかすっただけで計上すると表示率が実態より高く出る */
      var visible = Math.min(r.bottom, h) - Math.max(r.top, 0);
      var enough = visible > 0 && visible >= Math.min(r.height, h) * 0.25;
      if (enough) {
        push("section_view", {
          lp: page,
          section_id: el.getAttribute("data-ga-section")
        });
        pending.splice(i, 1);
      }
    }
  }

  /* スクロールの間引きは②と同じタイマーに相乗りさせる（下の checkAll を呼ぶ） */
  checkSections();
})();
